import { postJson, post } from '../../http'
export default {
  updatePrintPreviewImg(params) {
    // ConfiggureReports/PrintConfig/updatePrintPreviewImg
    return post('/ConfigureReports/PrintConfig/updatePrintPreviewImg', params)
  },
}
